import { CYCLE_COUNTS } from '../../../navigation/constants'

// Producer and consumer of the one deep link into a coverage event, kept in one file so the two
// cannot drift (the foundStockLinks rule). `event_id` opens the Eventos tab on that event's detail.
export const EVENT_QUERY_PARAM = 'event_id'

export const coverageEventDeepLink = (warehouseId, eventId) => {
  const qs = new URLSearchParams()
  qs.set(EVENT_QUERY_PARAM, String(eventId))
  return `${CYCLE_COUNTS.replace(':warehouse_id', encodeURIComponent(String(warehouseId)))}?${qs.toString()}`
}

// A positive integer, as a number or as its plain digits: the only shape an event id takes before
// it becomes a link or a request.
export const isCoverageEventId = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 && /^\d+$/.test(String(value))

// Parsed once per mount by the cycle-counts screen; anything that is not a positive integer is
// ignored rather than sent to the platform as an id.
export const parseCoverageEventDeepLink = search => {
  const raw = new URLSearchParams(search || '').get(EVENT_QUERY_PARAM)
  return isCoverageEventId(raw) ? Number(raw) : null
}
